export default __webpack_public_path__ + "static/media/package4.0efad872.png";